/**
 * @generated SignedSource<<abe2ce28ef8b54a2d9a1a9fd64191b75>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchConfluenceSpace_AtlassianSearchPage$data = {
  readonly __typename: "SearchConfluenceSpace";
  readonly description: string;
  readonly iconUrl: string | null;
  readonly id: string;
  readonly lastModified: string | null;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchConfluenceSpace_AtlassianSearchPage";
};
export type searchConfluenceSpace_AtlassianSearchPage$key = {
  readonly " $data"?: searchConfluenceSpace_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchConfluenceSpace_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchConfluenceSpace_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "iconUrl"
    },
    {
      "kind": "ScalarField",
      "name": "lastModified"
    }
  ],
  "type": "SearchConfluenceSpace"
};

(node as any).hash = "e00ee0f1a4a3e9cf3a591ff5b2be0406";

export default node;
